import { Behavior } from "../Behavior";
import type { IGrid } from "../types";
import type { Particle } from "../Particle";
import { Empty } from "../particles/Empty";

export class Lifetime extends Behavior {
    remaining: number;
    deathSpawnFactory?: () => Particle;

    constructor(min: number, max: number, deathSpawnFactory?: () => Particle) {
        super();
        this.remaining = Math.floor(Math.random() * (max - min + 1)) + min;
        this.deathSpawnFactory = deathSpawnFactory;
    }

    update(particle: Particle, grid: IGrid, index: number) {
        this.remaining--;
        if (this.remaining <= 0) {
            if (this.deathSpawnFactory) {
                grid.setIndex(index, this.deathSpawnFactory());
            } else {
                grid.setIndex(index, new Empty());
            }
            return -1;
        }
    }
}
